module.exports = __webpack_public_path__ + "img/news--stacker.5a655523.svg";